<template>
  <div class="content">
      <b-alert variant="info" dismissible fade v-if="debt_task" :show="showdebttaskalert" @dismissed="showdebttaskalert=false">
        <h4 class="alert-heading">Вам поставлен отработка по статусам должников с {{debt_task.start_date | datetimeFormat}} до {{debt_task.end_date | datetimeFormat}}</h4>
        <p class="mb-0">
          Дата окончания реестра: <strong>{{ debt_task.registry_date | dateFormat }}</strong>
        </p>
        <p class="mb-0">
          Вы можете работать только со следующими статусами:
          <strong v-for="(status, index) in debt_task.statuses" :key="status.id">
            {{status.name}} <i v-if="index+1 != debt_task.statuses.length">,</i>
          </strong>
        </p>
        <p class="mb-0">
          Вы можете работать только со следующими контрагентами:
          <strong v-for="(contragent, index) in debt_task.contragents" :key="contragent.id">
            {{contragent.name}} <i v-if="index+1 != debt_task.contragents.length">,</i>
          </strong>
        </p>
      </b-alert>

      <div class="row">
        <div class="col-sm-12 col-md-6">
          <a data-toggle="collapse" href="#filter" role="button" aria-expanded="false" aria-controls="filter">
            {{ $t('app.filter') }}
          </a>
          |
          <a data-toggle="collapse" href="#searchdebtor" role="button" aria-expanded="false" aria-controls="searchdebtor">
            {{ $t('app.find_debtor') }}
          </a>
        </div>
        <div class="col-sm-12 col-md-6">
          <div class="datatable_filter float-right">
            <div class="row">
              <div class="col">
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" id="showNextContactToday" v-model="showNextContactToday">
                  <label class="form-check-label" for="showNextContactToday">{{ $t('app.show_scheduled_for_today') }}</label>
                </div>
              </div>
              <div class="col">
                <div class="form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="showRecentlyTransferred"
                    v-model="filter.recently_transferred"
                    true-value="1"
                    false-value="0"
                    @change="fetchDebts"
                  >
                  <label class="form-check-label" for="showRecentlyTransferred">{{ $t('app.show_recently_transferred') }}</label>
                </div>
              </div>
              <div class="col">
                <label>
                  <select v-model="tableData.length" @change="fetchDebts()" class="form-control form-control-sm">
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                  </select>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="collapse" id="filter">
        <div class="block block-rounded block-bordered mb-3">
          <form @submit.stop.prevent="fetchDebts">
            <div class="block-content">
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="midlename" class="col-form-label">{{ $t('field.status') }}</label>
                    <select class="form-control form-control-sm" v-model="filter.status_id">
                      <option selected="true" value="">{{ $t('field.any') }}</option>
                      <option v-for="status in listDebtStatuses" :value="status.id" :key="status.id">
                        {{ status.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="col-form-label">{{ $t('field.contragent') }}</label>
                    <select class="form-control form-control-sm" v-model="filter.contragent_id">
                      <option selected="true" value="">{{ $t('field.any') }}</option>
                      <option v-for="contragent in listContragents" :value="contragent.id" :key="contragent.id">
                        {{ contragent.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="col-form-label">{{ $t('field.registry_date') }}</label>
                    <select class="form-control form-control-sm" v-model="filter.registry_date">
                      <option selected="true" value="">{{ $t('field.any') }}</option>
                      <option v-for="date in adminListRegistryDates" :value="date.registry_date" :key="date.registry_date">
                        {{ date.registry_date }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="datenextcontact" class="col-form-label">{{ $t('field.next_contact') }}</label>
                    <input type="date" class="form-control form-control-sm" id="datenextcontact" v-model="filter.next_contact">
                  </div>
                </div>
              </div>
            </div>
            <div class="block-content block-content-sm block-content-full">
                <div class="row">
                  <div class="col-12 text-center">
                    <div class="btn-group">
                      <button class="btn btn-success" type="submit">
                        <font-awesome-icon icon="search" /> {{ $t('field.find') }}
                      </button>
                      <button class="btn btn-danger" @click="resetForm()">
                        <font-awesome-icon icon="times" /> {{ $t('field.reset') }}
                      </button>
                    </div>
                  </div>
                </div>
            </div>
          </form>
        </div>
      </div>
      <div class="collapse" id="searchdebtor">
        <div class="block block-rounded block-bordered mb-3">
          <form @submit.stop.prevent="searchDebts">
            <div class="block-content">
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="midlename" class="col-form-label">{{ $t('debtors.lastname') }}</label>
                    <input type="text" class="form-control form-control-sm" :placeholder="$t('placeholder.enter_debtor_lastname')" id="midlename" v-model="filter.lastname">
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="name" class="col-form-label">{{ $t('debtors.firstname') }}</label>
                    <input type="text" class="form-control form-control-sm" :placeholder="$t('placeholder.enter_debtor_firstname')" id="name" v-model="filter.firstname">
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="lastname" class="col-form-label">{{ $t('debtors.middlename') }}</label>
                    <input type="text" class="form-control form-control-sm" :placeholder="$t('placeholder.enter_debtor_middlename')" id="lastname" v-model="filter.middlename">
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="birth_day" class="col-form-label">{{ $t('debtors.birth_day') }}</label>
                    <input type="date" class="form-control form-control-sm" id="birth_day" v-model="filter.birth_day">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="iin" class="col-form-label">{{ $t('debtors.iin') }}</label>
                    <input type="text" class="form-control form-control-sm" :placeholder="$t('placeholder.enter_debtor_iin')" id="iin" v-model="filter.iin">
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="debt_number" class="col-form-label">{{ $t('debts.number') }}</label>
                    <input type="text" class="form-control form-control-sm" :placeholder="$t('placeholder.enter_debt_number')" id="debt_number" v-model="filter.debt_number">
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="phone" class="col-form-label">{{ $t('field.phone') }}</label>
                    <input type="text" class="form-control form-control-sm" :placeholder="$t('placeholder.enter_debtor_phone')" id="phone" v-model="filter.phone">
                  </div>
                </div>
              </div>
            </div>
            <div class="block-content block-content-sm block-content-full">
                <div class="row">
                  <div class="col-12 text-center">
                    <div class="btn-group">
                      <button class="btn btn-success" type="submit">
                        <font-awesome-icon icon="search" /> {{ $t('field.find') }}
                      </button>
                      <button class="btn btn-danger" @click="resetForm()">
                        <font-awesome-icon icon="times" /> {{ $t('field.reset') }}
                      </button>
                    </div>
                  </div>
                </div>
            </div>
          </form>
        </div>
      </div>
      <div class="row">
        <div :class="{'col-md-12': !showNextContactToday, 'col-md-6':showNextContactToday }">
          <div class="block block-rounded">
            <div class="table-responsive">
              <datatable :columns="columns" :sortKey="sortKey" :sortOrders="sortOrders" :loading="loadDebts" @sort="sortBy" class="mb-0">
                  <tbody>
                    <tr
                      v-for="(debt, index) in debts"
                      :key="debt.id"
                      :class="{'table-danger': debt.next_contact < today, 'table-warning': debt.next_contact === today,'table-success': debt.next_contact > today, }"
                    >
                      <td>{{index+1}}</td>
                      <td class="text-center"><a :href="`debt/${debt.id}`" class="btn btn-sm btn-success" target="_blank"> Открыть</a></td>
                      <td>
                        {{debt.number}}<br>
                        <span class="badge badge-pill badge-danger" v-if="debt.risk_amount > 0 && debt.risk_date >= today">В зоне риска до {{debt.risk_date | dateFormat}}</span>
                        <h5 v-if="debt.company_id"><span class="badge badge-pill badge-success">{{debt.company.name}}</span></h5>
                      </td>
                      <td>{{debt.debtor ? debt.debtor.fullname:''}}</td>
                      <td>{{debt.debtor ? debt.debtor.iin : ''}}</td>
                      <td>
                        {{debt.status ? debt.status.name : ''}}
                        <h5 v-if="debt.recently_transferred">
                          <span class="badge badge-pill badge-info">Этот договор было недавно передано вам</span>
                        </h5>
                      </td>
                      <td>{{debt.user ? `${debt.user.lastname} ${debt.user.firstname}` : ''}}</td>
                      <td>{{debt.current_arrears}} <span v-if="debt.currency">{{debt.currency}}</span></td>
                      <td>
                        {{debt.last_contact | dateFormat}}
                      </td>
                      <td>
                        {{debt.next_contact| dateFormat}}<br>
                        <span v-if="debt.next_contact === today" class="badge badge-pill badge-danger">{{ $t('app.today') }}</span>
                        <span v-if="debt.next_contact === tomorrow" class="badge badge-pill badge-warning">{{ $t('app.tomorrow') }}</span>
                      </td>
                      <td>{{debt.start_date | dateFormat}}</td>
                      <td>{{debt.delay_credit_day}}</td>
                      <td>{{debt.amount_rewards}} <span v-if="debt.currency">{{debt.currency}}</span></td>
                    </tr>
                    <tr v-if="debts.length === 0 && !loadDebts">
                      <td colspan="13" class="text-center">{{ $t('app.empty') }}</td>
                    </tr>
                  </tbody>
              </datatable>
            </div>
          </div>
          <pagination :pagination="pagination" :offset="4" @paginate="fetchDebts()"/>
        </div>
        <div :class="{'d-none': !showNextContactToday, 'col-md-6':showNextContactToday }">
          <next-contact-48hours />
        </div>
      </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      debts: [],
      debt_task: null,
      today: moment().format('YYYY-MM-DD'),
      tomorrow: moment().add(1, 'days').format('YYYY-MM-DD'),
      columns: [
        { label: '#', name: 'index', disableOrder: true },
        { label: '', name: 'action', disableOrder: true },
        { label: this.$t('debts.number_short'), name: 'debts.number' },
        { label: this.$t('debtors.fullname'), name: 'debtors.fullname' },
        { label: this.$t('debtors.iin'), name: 'debtors.iin' },
        { label: this.$t('field.status'), name: 'debt_statuses.name' },
        { label: this.$t('users.user'), name: 'users.firstname' },
        { label: this.$t('debts.current_arrears'), name: 'debts.current_arrears' },
        { label: this.$t('debts.last_contact_short'), name: 'debts.last_contact' },
        { label: this.$t('debts.next_contact_short'), name: 'debts.next_contact' },
        { label: this.$t('debts.start_date'), name: 'debts.start_date' },
        { label: this.$t('debts.delay_credit_day'), name: 'debts.delay_credit_day' },
        { label: this.$t('debts.amount_rewards'), name: 'debts.amount_rewards', disableOrder: true },
      ],
      sortKey: 'name',
      sortOrders: {},
      tableData: {
        draw: 0,
        length: 10,
        search: '',
        column: 8,
        dir: 'asc',
      },
      filter: {
        lastname: '',
        firstname: '',
        middlename: '',
        iin: '',
        debt_number: '',
        birth_day: '',
        phone: '',
        status_id: '',
        next_contact: '',
        contragent_id: '',
        registry_date: '',
        recently_transferred: 0,
      },
      pagination: {
        current_page: 1,
      },
      showNextContactToday: false,
      loadDebts: false,
      showdebttaskalert: false,
    };
  },
  mounted() {
    this.fetchDebts();
    this.GET_ADMIN_LIST_REGISTRY_DATES();
    this.GET_LIST_DEBT_STATUSES();
    this.GET_LIST_CONTRAGENTS();
    this.columns.forEach((column) => {
      this.sortOrders[column.name] = -1;
    });
  },
  computed: {
    ...mapGetters([
      'listDebtStatuses',
      'listContragents',
      'adminListRegistryDates',
    ]),
  },
  methods: {
    ...mapActions([
      'GET_LIST_DEBT_STATUSES',
      'GET_LIST_CONTRAGENTS',
      'GET_ADMIN_LIST_REGISTRY_DATES',
    ]),
    fetchDebts() {
      this.loadDebts = true;
      this.tableData.draw += 1;
      const requests = { ...this.tableData, ...this.filter };
      window.axios.get(`/debts?page=${this.pagination.current_page}`, { params: requests })
        .then((res) => {
          if (this.tableData.draw === res.data.draw) {
            this.debts = res.data.debts.data;
            this.debt_task = res.data.debt_task;
            this.pagination = this.laraPaginate(res.data.debts);
          } else {
            console.log('failed');
          }
        })
        .catch(() => {
          console.log('err fetchDebt');
        })
        .finally(() => {
          this.loadDebts = false;
          if (this.debt_task) {
            this.showdebttaskalert = true;
          }
        });
    },
    searchDebts() {
      this.loadDebts = true;
      this.tableData.draw += 1;
      const requests = { ...this.tableData, ...this.filter };
      window.axios.get(`/debts?page=${this.pagination.current_page}`, { params: requests })
        .then((res) => {
          if (this.tableData.draw === res.data.draw) {
            this.debts = res.data.debts.data;
            this.debt_task = res.data.debt_task;
            this.pagination = this.laraPaginate(res.data.debts);
          } else {
            console.log('failed');
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loadDebts = false;
          if (this.debt_task) {
            this.showdebttaskalert = true;
          }
        });
    },
    resetForm() {
      this.filter.lastname = '';
      this.filter.firstname = '';
      this.filter.middlename = '';
      this.filter.iin = '';
      this.filter.debt_number = '';
      this.filter.birth_day = '';
      this.filter.phone = '';
      this.filter.status_id = '';
      this.filter.contragent_id = '';
      this.fetchDebts();
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableData.column = this.getIndex(this.columns, 'name', key);
      this.tableData.dir = this.sortOrders[key] === 1 ? 'asc' : 'desc';
      this.fetchDebts();
    },
  },
  components: {
    NextContact48hours: () => import('@/components/employee/nextContact48hours'),
  },
};
</script>
